import { DateValue } from "@ark-ui/react";

export default function isFocusedMonth(
  monthValue: number,
  focusedValue?: DateValue,
): boolean {
  if (!focusedValue) return false;
  return focusedValue.month === monthValue;
}
